import React from 'react';
import { Box, Container } from '@mui/material';
import MUITypography from '../../../Components/MUITypography';
import { align_center, align_column } from '../../../Styles/VMStyles';
import LandingToolBar from '../LangingToolBar';
import { isEmpty } from '../../../Util/UtilHelper';
import StorageFactory from '../../../Util/StorageFactory';
import { SESSION_USER_ID_KEY } from '../../../Util/VMConstants';
import FooterSection from '../FooterSection';

const sections = [
  {
    title: 'Acceptance of Terms',
    content:
      'By accessing or using the Venue Management application, you agree to be bound by these Terms and Conditions, as well as all applicable laws and regulations. If you do not agree with any part of these terms, you may not access the application.',
  },
  {
    title: 'User Accounts',
    content:
      'Sales executives are required to create user accounts using valid email addresses and passwords. Users are responsible for maintaining the confidentiality of their account information and are liable for all activities that occur under their account.',
  },
  {
    title: 'Venue and Customer Data',
    content:
      'Users are solely responsible for the accuracy and legality of the venue and customer data entered into the application. Venue Management shall not be held liable for any inaccuracies or violations of law resulting from user-generated content.',
  },
  {
    title: 'Subscription Services',
    content:
      'Sales executives may opt for subscription services to access additional features and benefits. Subscription fees are subject to change and are payable in accordance with the terms specified at the time of subscription.',
  },
  {
    title: 'Privacy Policy',
    content:
      'Venue Management respects the privacy of its users and is committed to protecting their personal information. Our Privacy Policy outlines how we collect, use, and disclose personal data. By using the application, you consent to the collection and processing of your data as described in the Privacy Policy.',
  }
];

function VMLandTerms() {

  const sessionFactory = new StorageFactory('session');
  const userID = sessionFactory.get(SESSION_USER_ID_KEY);

   return (
    <Box>
         {isEmpty(userID) && <LandingToolBar />}

        <Container maxWidth="md" >
        <MUITypography  align="center" gutterBottom sx={{margin:'20px',fontWeight: 700, ...align_center}}>
            Terms & Conditions
        </MUITypography>

        {sections.map((section, index) => (
            <Box key={index} sx={{ mt: 3 ,...align_column}}>
            < MUITypography sx={{ fontWeight: 600, mb: 1 }}>
                {index+1 + ". "+section.title}
            </MUITypography>
            <MUITypography  color="text.secondary" sx={{paddingLeft:'20px'}}>
                {section.content}
            </MUITypography>
            </Box>
        ))}
        </Container>
        <Box sx={{mt:2}}>
             <FooterSection/>
         </Box>
    </Box>
  )    
}

export default VMLandTerms